import last from 'lodash/last';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { UserContext } from 'components/signUpFunnel/Contexts';
import { BrandContext } from 'context/BrandContext';
import { TEMPO, STANDARD, FAMILY } from 'lib/constants';

const useFunnelMealPlan = () => {
  const location = useLocation();
  const { user } = useContext(UserContext);
  const { brand } = useContext(BrandContext);
  const mealPlanParam = last(location.pathname.split('/'));

  if (brand === TEMPO) {
    return TEMPO;
  } else if ([TEMPO, STANDARD, FAMILY].includes(mealPlanParam)) {
    return mealPlanParam;
  } else if (user && user.mealPlanSlug) {
    return user.mealPlanSlug;
  } else {
    return STANDARD;
  }
};

export default useFunnelMealPlan;
